import { FC } from 'react';
import { useHistory } from 'react-router-dom';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from '@mui/material/IconButton';

const BackButton: FC = () => {
  const history = useHistory();

  return (
    <IconButton size="small" onClick={() => history.goBack()}>
      <ArrowBackIcon />
    </IconButton>
  );
};

export default BackButton;
